import React from 'react';
import { RouterProvider } from 'react-router-dom';
import 'handsontable/dist/handsontable.full.min.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { registerAllModules } from 'handsontable/registry';
import router from 'components/routing/Routing';

registerAllModules();

const App: React.FC = () => {
  return (
    <RouterProvider router={router} />
  );
};

export default App;
